import DashboardLayout from '../layout/DashboardLayout.vue'
// GeneralViews
import NotFound from '../pages/NotFoundPage.vue'

import Vue from 'vue'
import Router from 'vue-router'
import store from "../vuex/store.js";
import Cookies from "js-cookie";


// Admin pages
import DeletedAccount from '../pages/DeletedAccount.vue'
import Support from '../pages/Support.vue'
import Home from '../pages/Home.vue'
import Empresas from '../pages/Empresas.vue'


Vue.use(Router)

const routes = [
  {
    path: '/admin',
    component: DashboardLayout,
    redirect: '/admin/overview',
    children: [
    ]
  },
  { path: '*', component: NotFound },
  { path: '/', component: Home },
  { path: '/borrar-cuenta', component: DeletedAccount },
  { path: '/soporte', component: Support },
  { path: '/empresas', component: Empresas },
]

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
